import { TranslateResult } from 'vue-i18n'

export const Roles = [
  {
    text: 'Admin',
    value: 'ADMIN',
  },
  {
    text: 'Agent',
    value: 'AGENT',
  },
  {
    text: 'Wholesaler',
    value: 'WHOLESALER',
  },
  {
    text: 'Employee',
    value: 'EMPLOYEE',
  },
  {
    text: 'Integration',
    value: 'INTEGRATION',
  },
  {
    text: 'Accountant',
    value: 'ACCOUNTANT',
  },
] as { text: string | TranslateResult; value: string }[]
